import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Kuutasu arvutamine

  <span style="color:#85c1dc;">**FI:**</span>
  Kuukausierän laskeminen

  <span style="color:#85c1dc;">**RU:**</span>
  Пример расчета
*/
/* @__NO_SIDE_EFFECTS__ */
const m840 = msg(
  mf`Kuutasu arvutamine`,
  mf`Kuukausierän laskeminen`,
  mf`Пример расчета`,
)

export { m840 as 'w.module.product_hero.monthly_calculate' }